import TeamsTable from './TeamsTableContainer';

export default TeamsTable;
